import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class RemoverCategoriaAdmin extends Component {


  state= {
    categoria:[],
    idcategoria:null,
    nome:null,
    error:null,
    success:null
  }

  async componentDidMount(){
    this.loadcategoria();
  

  }


  async loadcategoria () {

    const response = await api.post("/categorias/id", { idcategoria:this.props.match.params.idcategoria });
    this.setState({
      categoria:response.data,
      idcategoria:this.props.match.params.idcategoria
    })
  }

  delcat = async e => {
    e.preventDefault();
    const { idcategoria } = this.state;
      if (!idcategoria) {
          this.setState({ error: "Ocorreu um erro!",
        success:null });
          
      } else {
      const { idcategoria } = this.state;
      const response = await api.post("/admin/categoria/del", { idcategoria });

        if(response.data.deleted_at){
          this.setState({ success: "Categoria Deletada!" , error:null, nome:null });


        this.props.history.push("/admin/categoria");
        }

      }
  }
 



  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-6 p-4">     

        <h4>Remover Categoria</h4>     
        <form onSubmit={this.delcat}>
               
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" value={this.state.categoria.nome} placeholder="Novo Nome" />
                </div>
                <div class="form-group">
                <button class="btn btn-danger mb-2" type="submit">Excluir Categoria</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(RemoverCategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/removecategoria.js